import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { toggleRibbon } from '../../actions'

function mapStateToProps(state) {
    return {
        open: state.getIn(['ui', 'ribbon', 'open']),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleRibbonAction: bindActionCreators(toggleRibbon, dispatch),
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        static propTypes = {
            open: PropTypes.bool.isRequired,
            show: PropTypes.bool.isRequired,
        }

        shouldComponentUpdate(nextProps) {
            if (this.props.open !== nextProps.open) return true
            if (this.props.show !== nextProps.show) return true

            return false
        }

        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
